import { devlog } from "../../logic/utils.ts";
import '../base/buttons/as-icon-button';
import styleText from './as-feature-controls.css?raw';

export class AsFeatureControls extends HTMLElement {
  private static readonly sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();

  static get observedAttributes() {
    return ['hide-help', 
      'hide-settings', 'hide-toggle-workpiece-view', 'hide-transfer-mesh','hide-all-defaults'
    
    ];
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      AsFeatureControls.sheet
    ];

    this.shadowRoot!.innerHTML = /*html*/`
      <as-panel class="placement ${this.hasAttribute('hide-defaults') ? 'hide-defaults' : ''}">
        <slot name="top"></slot>
        <slot name="middle">
        </slot>
        <as-icon-button 
          id="features-toggle-workpiece-view-button" 
          tooltip-placement="left" 
          class="default-feature-button"
          name="toggle-workpiece-view"
          tooltip-dict-key="tooltip.feature.toggle-workpiece-view"

          black 
          
          icon-set="toggle-workpiece-view"
          icon-variant="default"
          ></as-icon-button>
        <as-icon-button id="features-transfer-mesh-button" class="default-feature-button ${this.hasAttribute('hide-transfer-mesh') ? 'hidden' : ''} " name="transfer-mesh" tooltip-placement="left" black file-name="/features/next-b.svg" tooltip-dict-key="tooltip.feature.transfer-mesh"></as-icon-button>
        <slot name="bottom"></slot>
      </as-p>
    `;  
    
  }

  
  /**
   * When the component is connected to the DOM, create the template
   * and set up the popout button and card
   */
  connectedCallback() {
    window.addEventListener('as-workpiece-visibility-change',this.handleWorkpieceVisibilityChange.bind(this))
  }
  handleWorkpieceVisibilityChange = (ev:CustomEvent)=>{
    devlog("workpiece visibility change", ev.detail)
    const visible = ev.detail.visible;
    if(visible){
      this.shadowRoot!.querySelector('#features-toggle-workpiece-view-button')!.setAttribute('icon-variant','default');
    }else{
      this.shadowRoot!.querySelector('#features-toggle-workpiece-view-button')!.setAttribute('icon-variant','hidden');
    }
  }
  /**
   * Clean up when the component is removed
   */
  disconnectedCallback() {
    window.removeEventListener('as-workpiece-visibility-change',this.handleWorkpieceVisibilityChange)
  }
  
  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (name === 'hide-defaults') {
      const attrPresent = this.hasAttribute('hide-defaults');  
      if (attrPresent) {
        this.shadowRoot!.querySelector('.placement.hide-defaults')?.classList.add('hidden');
      } else {
        this.shadowRoot!.querySelector('.placement.hide-defaults')?.classList.remove('hidden');
      }
    }
    if (name === 'hide-help') {
      const attrPresent = this.hasAttribute('hide-help');  
      if (attrPresent) {
        this.shadowRoot!.querySelector('#features-help-button')?.classList.add('hidden');
      } else {
        this.shadowRoot!.querySelector('#features-help-button')?.classList.remove('hidden');
      }
    }
    if (name === 'hide-settings') {
      const attrPresent = this.hasAttribute('hide-settings');  
      if (attrPresent) {
        this.shadowRoot!.querySelector('#features-settings-button')?.classList.add('hidden');
      } else {
        this.shadowRoot!.querySelector('#features-settings-button')?.classList.remove('hidden');
      }
    }
    if (name === 'hide-toggle-workpiece-view') {
      const attrPresent = this.hasAttribute('hide-toggle-workpiece-view');  
      if (attrPresent) {
        this.shadowRoot!.querySelector('#features-toggle-workpiece-view-button')?.classList.add('hidden');
      } else {
        this.shadowRoot!.querySelector('#features-toggle-workpiece-view-button')?.classList.remove('hidden');
      }
    }
    if (name === 'hide-transfer-mesh') {
      const attrPresent = this.hasAttribute('hide-transfer-mesh');  
      if (attrPresent) {
        this.shadowRoot!.querySelector('#features-transfer-mesh-button')?.classList.add('hidden');
      } else {
        this.shadowRoot!.querySelector('#features-transfer-mesh-button')?.classList.remove('hidden');
      } 
    }
  }
}

// Check if the element is already defined before registering it
if (!customElements.get('as-feature-controls')) {
  customElements.define('as-feature-controls', AsFeatureControls);
} else {
  console.warn("as-feature-controls already defined");
}  
